<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__container">
        <p>
          Muchas gracias por completar la información.<br /><br />
          Tu trámite se registró correctamente, y se le notificará al nuevo
          vecino para que continúe con el mismo.<br /><br />
          Te recordamos que el proceso finalizará una vez que se completen todas
          las etapas.
        </p>
        <div
          class="empadronamiento__intro__button justify-center"
          style="margin-top: 10px;"
        >
          <div></div>
          <button class="active" @click="goToProfile">IR A 'SOY VECINO'</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToProfile() {
      window.location = process.env.VUE_APP_LINK_MI_CUENTA;
    },
  },
  mounted() {
    const popHandler = () => {
      window.history.forward();
      setTimeout(() => {
        window.addEventListener("popstate", popHandler, { once: true });
      }, 50); // delay needed since the above is an async operation for some reason
    };
    window.addEventListener("popstate", popHandler, { once: true });
    window.history.pushState(null, null, null);
  },
};
</script>

<style></style>
